import { TextFieldProps, Typography } from '@mui/material';

export const InputLabel = ({
  label,
  id,
}: {
  id: string;
  label: TextFieldProps['label'];
}) => {
  return (
    <Typography
      variant="body3"
      sx={{ mb: 0.5 }}
      component="label"
      htmlFor={id || `text-input-${id}`}>
      {label}
    </Typography>
  );
};
